import {useContext} from "react";
import {ReducerContext} from "../reducer";

function Project({onClickProject, p}) {
    const {state,} = useContext(ReducerContext)
    const isActive = state.status?.session?.projectId === p.id
    const _onClickProject = () => {
        if (isActive) {
            return
        }
        onClickProject(p.Project.id)
    }

    return (
        <div className={"project-row" + (isActive ? " selected" : "")}>
            <div onClick={_onClickProject}
                 className={"row table-row inner-project-row g-0 d-none d-md-flex"}>
                <div className="col-2 col-lg-1 id d-flex justify-content-center"><span>{p.id}</span></div>
                <div className="col-2 col-lg-3 customer"><span
                    className="text-truncate w-100 pe-1">{p.customer || '-'}</span></div>
                <div className="col-4 col-lg-5 projectName">
                    <span className="text-truncate w-100" title={p.name}>{p.name}</span>
                </div>
                <div className="col-2 col-lg-2">
                        <span className="text-truncate w-100"
                              title={new Date(p.Project.usagePeriodStart).toLocaleDateString()}>{new Date(p.Project.usagePeriodStart).toLocaleDateString()}
                </span>
                </div>
                <div className="col-2 col-lg-1 time-cell d-flex justify-content-center">
                    <span>{p.hours < 10 ? "0" : ""}{p.hours}:{p.minutes < 10 ? "0" : ""}{p.minutes}:{p.seconds < 10 ? "0" : ""}{p.seconds}</span>
                </div>
            </div>
            <div onClick={_onClickProject}
                 className={"row table-row inner-project-row g-0 d-md-none"}>
                <div className="col-2 id d-flex justify-content-center"><span>{p.id}</span></div>
                <div className="col-2 customer"><span
                    className="text-truncate w-100 pe-1">{p.customer || '-'}</span></div>
                <div className="col-6 projectName justify-content-center flex-column">
                    <div className="hstack">
                        <span className="text-truncate w-100" title={p.name}>{p.name}</span>
                    </div>
                    <span className="text-truncate w-100"
                          title={new Date(p.Project.usagePeriodStart).toLocaleDateString()}>{new Date(p.Project.usagePeriodStart).toLocaleDateString()}</span>
                </div>
                <div className="col-2 time-cell d-flex justify-content-center">
                    <span>{p.hours < 10 ? "0" : ""}{p.hours}:{p.minutes < 10 ? "0" : ""}{p.minutes}:{p.seconds < 10 ? "0" : ""}{p.seconds}</span>
                </div>
            </div>
        </div>
    )
}

export default Project